import React, { useRef } from 'react'
import { useIntersection } from 'react-use'
import { motion } from 'framer-motion'
import AnimationLayout from '../components/AnimationLayout'
import MatildeBalloon from '../components/MatildeBalloon'
import Button from '../components/Button'

const Help = () => {
    const initialRef = useRef(null)
    const purposeRef = useRef(null)
    const narrativesRef = useRef(null)
    const progressionRef = useRef(null)
    const buttonRef = useRef(null)

    const intersection = useIntersection(buttonRef, {
        root: null,
        rootMargin: '400px',
        threshold: 1
    });

    const scrollToRef = (ref) => {
        const scrollDirection = ref.current.offsetTop - 50
        window.scrollTo(0, scrollDirection)
    }

    console.log(intersection && intersection.intersectionRatio < 1)
    console.log(intersection)

    return (
        <AnimationLayout>
            <h1 ref={initialRef}>Ajuda</h1>
            <MatildeBalloon>
                <p>Nesta página poderá informar-se melhor acerca do Adventour e perceber o seu funcionamento caso tenha dúvidas do mesmo o que é bastante útil para perceber toda a lógica da progressão da sua personagem e do que pode fazer no website!</p>
            </MatildeBalloon>

            <div className='white-container pb-8'>
                <h2>Tópicos</h2>
                <ul className='help-list flex flex-col'>
                    <li onClick={() => scrollToRef(purposeRef)}><span>Objetivo do jogo</span></li>
                    <li onClick={() => scrollToRef(progressionRef)}><span>Progressão</span></li>
                    <li onClick={() => scrollToRef(narrativesRef)}><span>Narrativas</span></li>
                </ul>
            </div>

            <div ref={purposeRef}>
                <h3 className='pb-2'>Objetivo do jogo</h3>
                <p className='pb-2'>Todo o objetivo e propósito da experiência Adventour foca-se, principalmente, na realização de viagens por certos destinos que consistem numa narrativa com diferentes contéudos que o utilizador poderá interagir. Estas narrativas são veículos para informar o utilizar dos cuidados que são necessários para viajar quer seja de saúde ou de segurança, as culturas dos países em questão e o poder das notícias no que toca à preparação de realizar viagens. Quando o utilizador termina a narrativa receberá diferentes recompensas.</p>
                <p className='pb-2'>Para além disso, o objetivo do jogo passa, também, pela concretização de partidas do Mundo em Notícias, um pequeno minijogo minimamente dinámico que possuí 10 rondas com 1 notícia diferente por ronda. Em cada ronda será mostrado um minijogo familiar, cujo conteúdo assenta na notícia da ronda em questão, que o utilizador terá de concretizar. Igualmente às narrativas, este jogo recompensará o utilizador quando este o terminar, como fotos, itens e experiência.</p>
                <p className='pb-2'>Estas duas experiências, as narrativas e o Mundo em Notícias, estão ligados pois as recompensas do Mundo em Notícias serão potencialmente utéis para realizar as narrativas.</p>
                <p>O termo de experiência será melhor explicado na secção abaixo de progressão, visto que está ligado à progressão do personagem.</p>
            </div>

            <hr className='my-10 h-2 rounded-full bg-gray-500' />

            <div ref={progressionRef}>
                <h3 className='pb-2'>Progressão</h3>
                <p className='pb-2'>Relativamente à progressão, este elemento é bastante importante no Adventour. Todos os utilizadores possuem um nível e pontos de experiência, elementos representados na barra lateral no canto superior esquerdo. O nível inicial é 1 e o máximo é 10. No decorrer da realização dos objetivos do jogo, referidos acima (narrativas e Mundo em Notícias) o utilizador irá receber pontos de experiência podendo, assim, subir de nível quando atingir um montante estipulado de pontos de experiência. Cada nível terá um montante estipulado distinto. Por exemplo, o nível 1 terá 50 pontos de experiência como limite, se o utilizador ultrapassar esses pontos subirá para o nível 2. Já o nível 7 tem um limite de 650 pontos de experiência.</p>
                <p>Continuando, a progressão é importante já que o utilizador terá diferentes narrativas bloqueados ou desbloqueados conforme o seu nível, por exemplo, a narrativa que conta a viagem para a Grécia encontra-se desbloqueada para todos os utilizadores com pelo menos nível 1. Todavia, a narrativa que descreve a aventura no Sri Lanka só será possível experenciar quando o utilizador atingir o nível 2.</p>
            </div>

            <hr className='my-10 h-2 rounded-full bg-gray-500' />

            <div ref={narrativesRef} className='pb-10'>
                <h3 className='pb-2'>Narrativas</h3>
                <p className='pb-2'>As narrativas são o elemento principal do Adventour, são elas que contam as histórias das viagens da Matilde e são o meio para informar o utilizar dos cuidados de saúde ou de segurança para viajar, as culturas específica de um paíse o poder das notícias no que toca à preparação de realizar viagens e compreender melhor o mundo.</p>
                <p className='pb-2'>Existem quatro narrativas diferentes em países distintos (Grécia, Sri-Lanka, Brasil e China), que, podem ser consideradas como diferentes livros ou, em termos mais direcionados para um jogo, etapas.  Como referido anteriormente estas narrativas podem encontrar-se bloqueados ou desbloqueadas conforme o nível do utilizador. Continuando, dentro de cada livro/etapa irão existir 3 capítulos/missões que serão realizados de forma cronológica e progressiva, isto é, o utilizador terá de terminar o capítulo 1 para acessar ao capítulo 2.</p>
                <p>Para concluir, dentro de cada capítulo existirão diferentes formas de interação, desde minijogos, disposição de notícias e gráficos de fontes crediveís entre outros que, terão sempre acompanhados de instruções e um botão de ajuda para explicar os procedimentos necessários para concluir a tarefa proposta ao utilizador.</p>
            </div>

            <div ref={buttonRef} className='white-container pb-8'>
                <h5 className='text-center w-full'>Esperemos que esta página tenha sido útil para perceber melhor o funcionamento do Adventour, caso ainda possua dúvidas envie-nos um email com a mesma para podermos ajudar - gameadventour@gmail.com</h5>
            </div>

            <motion.div
                initial="collapsed"
                animate={(intersection && intersection.intersectionRatio >= 1) ? "open" : "collapsed"}
                exit="collapsed"
                variants={{
                    open: { opacity: 1, display: 'block', position: 'fixed', height: 'auto', bottom: '5%', right: '3.5%' },
                    collapsed: { opacity: 0, height: 0, transition: { duration: 0.5, ease: 'easeInOut' }, transitionEnd: { display: 'none' } }
                }}
            >
                <Button
                    className='rounded-full'
                    onClick={() => scrollToRef(initialRef)}
                >
                    <img className='transform rotate-90' src={require('../assets/icons/32/arrow-left-32.png')} alt='olá' />
                </Button>
            </motion.div>

        </AnimationLayout>
    )
}

export default Help